import { prefersReducedMotion } from './motion';

const ROTATION_INTERVAL = 4200;
const TRANSITION_DURATION = 600;
const EXIT_CLASS = 'is-leaving';
const ACTIVE_CLASS = 'is-active';

export function initTreeRotator(): void {
  const wrappers = Array.from(document.querySelectorAll<HTMLUListElement>('[data-tree-rotation]'));
  if (wrappers.length === 0 || prefersReducedMotion()) return;

  wrappers.forEach((wrapper) => {
    const items = Array.from(wrapper.querySelectorAll<HTMLElement>('li'));
    if (items.length < 2) return;

    wrapper.classList.add('has-tree-rotator');
    wrapper.style.position = 'relative';
    wrapper.style.overflow = 'hidden';

    const tallest = items.reduce(
      (max, item) => Math.max(max, item.offsetHeight || item.scrollHeight || item.getBoundingClientRect().height || 0),
      0
    );
    const minHeight = Math.max(tallest, wrapper.scrollHeight || 0);
    if (minHeight) {
      wrapper.style.minHeight = `${minHeight}px`;
    }

    let activeIndex = 0;
    items.forEach((item, index) => {
      item.classList.toggle(ACTIVE_CLASS, index === activeIndex);
      item.classList.remove(EXIT_CLASS);
      item.style.position = 'absolute';
      item.style.inset = '0';
      item.style.width = '100%';
      item.style.margin = '0';
      item.style.transition = `opacity ${TRANSITION_DURATION}ms cubic-bezier(0.22, 0.61, 0.36, 1), transform ${TRANSITION_DURATION}ms cubic-bezier(0.22, 0.61, 0.36, 1)`;
    });

    window.setInterval(() => {
      const previousIndex = activeIndex;
      const nextIndex = (activeIndex + 1) % items.length;
      if (nextIndex === previousIndex) return;

      const previousItem = items[previousIndex];
      const nextItem = items[nextIndex];

      previousItem.classList.remove(ACTIVE_CLASS);
      previousItem.classList.add(EXIT_CLASS);
      nextItem.classList.add(ACTIVE_CLASS);

      activeIndex = nextIndex;

      window.setTimeout(() => {
        previousItem.classList.remove(EXIT_CLASS);
      }, TRANSITION_DURATION + 40);
    }, ROTATION_INTERVAL);
  });
}
